import { Link } from 'react-router-dom';
import { useLocale, useT, withLocale } from '../i18n';
import { useApiData } from '../api/useApiData';
import { contentApi } from '../api/content';
import AsyncSection from '../components/shared/AsyncSection';

export default function SolutionsHub() {
  const locale = useLocale();
  const t = useT();
  const state = useApiData(() => contentApi.solutions(locale), [locale]);

  return (
    <section className="section" style={{ paddingTop: 160 }}>
      <div className="container">
        <div className="section-head reveal is-visible">
          <span className="eyebrow">{t('solutions.eyebrow')}</span>
          <h1>{t('solutions.h1')}</h1>
          <p className="body-lg">{t('solutions.lead')}</p>
        </div>
        <AsyncSection
          state={state}
          render={(solutions) => (
            <div className="card-grid">
              {solutions.map((s) => (
                <Link className="card reveal is-visible" to={withLocale(`/solutions/${s.slug}`, locale)} key={s.code}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span className="badge badge-core">{s.classification}</span>
                    {s.externalUrl && (
                      <span className="badge" style={{ background: 'rgba(91, 155, 255, 0.15)', color: '#5B9BFF', borderColor: 'rgba(91, 155, 255, 0.4)' }}>
                        🛡️ Dedicated Website
                      </span>
                    )}
                  </div>
                  <h3 style={{ marginTop: 12 }}>
                    {s.code} — {s.name}
                  </h3>
                  <p className="body-sm">{s.problem}</p>
                  <span className="card-link">
                    {s.externalUrl ? (locale === 'ar' ? 'عرض التفاصيل ورابط الموقع ←' : locale === 'fr' ? 'Détails & Site dédié →' : 'Details & Dedicated Site →') : '→'}
                  </span>
                </Link>
              ))}
            </div>
          )}
        />
      </div>
    </section>
  );
}
